import { Component, ChangeDetectionStrategy } from '@angular/core'
import { ModalShellComponent } from '../modal-shell/modal-shell.component'

/**
 * UpdateModalComponent — blocking "please refresh" prompt shown once
 * VersionCheckService detects a newer deployed build.
 *
 * Deliberately non-dismissible: `closeOnBackdrop` is false and no `(closed)`
 * handler is bound, so Escape/backdrop do nothing. The only way forward is the
 * single "Refresh now" action, which reloads the page into the new bundle.
 * We can't force a reload (the user may have unsaved work) — hence the copy
 * asking them to save first.
 */
@Component({
  selector: 'app-update-modal',
  standalone: true,
  imports: [ModalShellComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-modal-shell activityName="update"
      title="A new version is available"
      size="sm"
      [closeOnBackdrop]="false">

      <p class="update-copy">
        The application was updated. Refresh to continue — the app may not work
        correctly until you do. Changes you've applied are already saved.
      </p>

      <div actions>
        <button class="btn btn-primary" (click)="refresh()">Refresh now</button>
      </div>

    </app-modal-shell>
  `,
  styles: [`
    .update-copy {
      margin: 0;
      font-size: 0.9rem;
      line-height: 1.5;
      color: var(--color-text-secondary);
    }
  `]
})
export class UpdateModalComponent {
  refresh(): void {
    window.location.reload()
  }
}
